// Pinia store module
// School data feed statuses

/* Generic interface for sbdata-* stores:
   - Getter ready() returns true iff data is available
   - Action async load() triggers fetching of data from the server, the
      returned promise is rejected if data cannot be loaded.
*/

import { defineStore } from 'pinia'
import { ref, reactive, computed } from 'vue'

import { useSbuserStore } from '../auth/sbuser-store.mjs'

import { debug } from '@/lib/sb_utility.mjs'
function myDebug(msg){debug(msg, 'dlstore')}


const reportsFolder = 'app_88001_exclusions-la-monitor/reports/'

export const useDownloadsStore = defineStore('downloads', ()=>{

   // Standard data page interface...
   const dataStatus = ref(0) //2 = loaded, 1 = loading, -1 = error, -2 = not authorized
   // Store-specific data...
   const content = reactive({})

   return {
      // State
      dataStatus,
      content,

      // Getters
      loadStatus: computed(()=>dataStatus.value),
      ready: computed(()=>(dataStatus.value>1)),

      // Actions
      async load(_options){ 
         myDebug("load data")
         dataStatus.value = 1
         const sbuser = useSbuserStore()

         try {
            myDebug("Request data")
            let response = await sbuser.sbdataGet("file/x/" + reportsFolder)
            if(response.ok){
               // Import schools data from file
               myDebug("Process datafile")
               let indexObj = await response.json()
               for(let p in indexObj) content[p] = indexObj[p]
               dataStatus.value = 2
            } else if(response.status == 403){
               myDebug("Not authorized")
               dataStatus.value = -2
            } else if(response.status == 401){
               myDebug("Not authenticated")
               //TODO: Handle logged out user
               dataStatus.value = -2
            } else {
               myDebug("Unknown error")
               dataStatus.value = -1
            }
         } catch(err){
            myDebug(err)
            dataStatus.value = -3
         }
         myDebug("done")
      },

   }
})
